import React from "react";
import useScrollProgress from "../hooks/useScrollProgress";

export default function ScrollProgress() {
  const progress = useScrollProgress();

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-x-0 top-0 z-[950] h-0.5 mix-blend-difference"
    >
      <i
        className="block h-full origin-left bg-paper"
        style={{ transform: `scaleX(${progress})` }}
      />
    </div>
  );
}
